<template lang="pug">
  #valid-sheets
    multiple-row-action(
      :selection-count="duplicateSheetSelectionCount"
      :actions="groupActions"
      :units="groupUnits"
      @remove="removeSelectedSheets"
      @selectAll="$refs.sheetAggregateList.selectAll()"
      @deselectAll="$refs.sheetAggregateList.deselectAll()"
    )
    sheet-aggregate-list(
      ref="sheetAggregateList"
      :sheet-aggregates="validSheetAggregates"
      :actions="listActions"
      :loading="loading"
      @remove="removeSheet"
      @selection="setSelectedSheetIds"
      @hover="aggregateHoverHandler"
    )
      template(v-slot:header="")
        li.header.item-container
          .attribute.select-aggregate
          .attribute.source-sit-id SIT source
          ol.responsive-table
            li.item-container
              .attribute.destination-name importée pour le DMO
              .attribute.aspect aspect
              .attribute.hawwwai-id ID Hawwwai
              .attribute.thumbnail
              .attribute-container.sheet-info
          .attribute-container.actions
    remove-sheets-modal(
      ref="removeSheetsModal"
      :establishment="establishment"
      :potential-establishments="potentialEstablishments"
      @remove="$emit('update')"
    )
</template>

<script>
import SheetAggregateList from '@/components/sheet-aggregate-list/SheetAggregateList.vue';
import MultipleRowAction from '@/components/MultipleRowAction.vue';
import RemoveSheetsModal from './remove-sheets-modal/RemoveSheetsModal.vue';
import sheetService from '@/services/sheets.js';

export default {
  components: {
    SheetAggregateList,
    MultipleRowAction,
    RemoveSheetsModal,
  },
  props: {
    establishment: {
      type: Object,
      required: true,
    },
    potentialEstablishments: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      listActions: [{ label: "Retirer de l'établissement", event: 'remove' }],
      groupActions: [{ label: "Retirer $count $unit de l'établissement", event: 'remove' }],
      groupUnits: { singular: 'fiche', plural: 'fiches'},
      validSheetAggregates: [],
      selectedSheetIds: [],
      loading: false,
    };
  },
  mounted () {
    this.getValidSheetAggregates();
  },
  methods: {
    async getValidSheetAggregates() {
      this.selectedSheetIds = [];
      this.loading = true;
      this.validSheetAggregates = await sheetService.getAggregatesByEstablishmentId(this.establishment.id);
      this.loading = false;
      this.$emit('getSheets', this.validSheetAggregates);
    },
    setSelectedSheetIds({ selected }) {
      this.selectedSheetIds = selected;
    },
    removeSelectedSheets() {
      const selectedSheets = this.validSheetAggregates.filter(it => this.selectedSheetIds.includes(it.reference.value));
      this.$refs.removeSheetsModal.sheetAggregates = selectedSheets;
      this.goToRemoveSheets();
    },
    removeSheet({ sheetAggregateId }) {
      const sheet = this.validSheetAggregates.find(it => sheetAggregateId === it.reference.value);
      this.$refs.removeSheetsModal.sheetAggregates = [sheet];
      this.goToRemoveSheets();
    },
    goToRemoveSheets() {
      if (this.$route.name !== 'SheetsPreview') {
        this.$router.replace({ name: 'SheetsPreview' });
      }
    },
    aggregateHoverHandler({ sheet }) {
      this.$emit('hover', { sheet });
    },
  },
  computed: {
    duplicateSheetSelectionCount() {
      return this.selectedSheetIds.reduce((acc, it) => {
        const sheetAggregate = this.validSheetAggregates
          .find(sheet => sheet?.reference?.value === it);
        if (sheetAggregate) {
          acc += sheetAggregate.sheets.length;
        }
        return acc;
      }, 0);
    }
  },
}
</script>

<style lang="scss">
  #valid-sheets {
    .header.item-container {
      grid-template-columns: 5em 14em 1fr 10em;
      font-size: 16px;
      padding: 1em 0;
      color: #ADADAD;
      .responsive-table {
        .item-container {
          grid-template-columns: 8em 6em 8em 180px 1.5fr;
        }
      }
    }
    .sheet-aggregate-list {
      &.empty,.load-content {
        min-height: 20em;
      }
    }
  }
</style>